import PropTypes from 'prop-types';

export const rolesPropTypes = PropTypes.shape({
  roleId: PropTypes.string.isRequired,
  roleName: PropTypes.string.isRequired,
});
